import { useDepartmentText } from 'model/DepartmentTerminology';
import RestrictionSelectBaseFilter, {
  RestrictionSelectFilterBaseProps,
} from 'components/tables/filters/restriction/RestrictionSelectBaseFilter';
import { useMemo } from 'react';

/**
 * Filter component for the restriction column with three options - global, organization and department.
 */
export default function ThreeRestrictionsSelectFilter(props: RestrictionSelectFilterBaseProps) {
  const departmentText = useDepartmentText();
  const options = useMemo(
    () => [
      { value: 'global', label: 'Globálne' },
      { value: 'organization', label: 'Organizácia' },
      { value: 'department', label: departmentText('Položka úrovne', 'Stredisko') },
    ],
    [departmentText]
  );

  return <RestrictionSelectBaseFilter {...props} data={options} />;
}
